import{classAdderBuilder as a}from"../../common/dist/classadder/classAdderBuilder.js";var d=a({class:"mdc-text-field__affix mdc-text-field__affix--prefix",tag:"span"});export{d as default};
//# sourceMappingURL=Prefix.js.map
